import React from 'react';
import { useTranslation } from 'react-i18next';
import CustomDialog from 'components/custom-dialog/custom-dialog.component';
import GiftCardAddValue from 'components/card-item/card-item-giftcard/giftcard-add-value/giftcard-add-value.component';
import PurchaseGiftCardFraudNotice from 'components/purchase-gift-card-fraud-notice/purchase-gift-card-fraud-notice.component';

const PurchaseGiftCard = ({ open, handleClose }) => {
  const { t } = useTranslation();

  return (
    <>
      <CustomDialog
        open={open}
        close={handleClose}
        title={t('addPurchaseGiftCard.purchaseCard.title')}
        tabIndex="0"
        testId="PurchaseGiftCard.CustomDialog"
      >
        <GiftCardAddValue handleClose={handleClose} />
        <PurchaseGiftCardFraudNotice />
      </CustomDialog>
    </>
  );
};
export default PurchaseGiftCard;
